import { InfoSet } from "../InfoSets/InfoSet";
import { HashSet } from "../Utils/HashSet";
import { IpMacBinding } from "../Core/IpMacBinding";
import { Device } from "../Core/Device";
import { IpAddress } from "../Core/IpAddress";
import { MacAddress } from "../Core/MacAddress";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";

export class AddressInfo extends InfoSet {

	public IpMacAddresses: HashSet<IpMacBinding>;

	constructor(device: Device) {
		super(device);
		this.IpMacAddresses = new HashSet<IpMacBinding>();
	}

	public Clear(): void {
		this.IpMacAddresses.Clear();
	}

	public AddIpMac(ipMac: IpMacBinding): void {
		this.IpMacAddresses.Add(ipMac);
	}

	public RemoveIpMac(ipMac: IpMacBinding): void {
		this.IpMacAddresses.Remove(ipMac);
	}

	public get HasIpAddresses(): boolean {
		return true;
	}

	public get IpAddresses(): HashSet<IpAddress> {
		let result = new HashSet<IpAddress>();

		this.IpMacAddresses.ForEach((ipMac: IpMacBinding) => {
			if (ipMac.HasIp)
				result.Add(ipMac.Ip);
		});

		return result;
	}

	public get HasMacAddresses(): boolean {
		return true;
	}

	public get MacAddresses(): HashSet<MacAddress> {
		let result = new HashSet<MacAddress>();

		this.IpMacAddresses.ForEach((ipMac: IpMacBinding) => {
			if (ipMac.HasMac)
				result.Add(ipMac.Mac);
		});

		return result;
	}

	public Write(obj: any, context: any): void {
		obj.addr_info = {};
		obj = obj.addr_info;

		obj.ip_mac_addresses = [];
		ObjSerUtils.WriteObjSerCollection(obj.ip_mac_addresses, this.IpMacAddresses, context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.addr_info)
			throw new Error();
		obj = obj.addr_info;

		this.Clear();

		if (obj.ip_mac_addresses !== undefined) {
			ObjSerUtils.ReadObjSerCollection(obj.ip_mac_addresses, this.IpMacAddresses,
				(value: any) => new IpMacBinding(), context);
		}
	}

}
